<script>
    export let variant = 'left';
</script>

{#if variant === 'right'}
    <svg width="100%" height="100%" viewBox="0 0 63 62" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.83594 31.0059C1.83594 23.0186 5.0089 15.3584 10.6568 9.7105C16.3047 4.0626 23.9649 0.889648 31.9522 0.889648L31.9522 11.4303C26.7605 11.4303 21.7813 13.4928 18.1102 17.1639C14.4391 20.835 12.3766 25.8142 12.3766 31.0059L1.83594 31.0059Z"
            fill="url(#paint0_linear_10743_353686_1)"
        />
        <path
            d="M62.0686 31.0059C62.0686 23.0186 58.8956 15.3584 53.2477 9.7105C47.5998 4.0626 39.9397 0.889648 31.9523 0.889648L31.9523 11.4303C37.1441 11.4303 42.1232 13.4928 45.7943 17.1639C49.4655 20.835 51.5279 25.8142 51.5279 31.0059L62.0686 31.0059Z"
            fill="url(#paint1_linear_10743_353686_2)"
        />
        <path
            d="M62.0686 31.0058C62.0686 38.9931 58.8956 46.6533 53.2477 52.3012C47.5998 57.9491 39.9397 61.1221 31.9523 61.1221L31.9523 50.5814C37.1441 50.5814 42.1232 48.5189 45.7943 44.8478C49.4655 41.1767 51.5279 36.1976 51.5279 31.0058L62.0686 31.0058Z"
            fill="url(#paint2_linear_10743_353686_4)"
        />
        <path
            d="M1.83594 31.0058C1.83594 38.9931 5.0089 46.6533 10.6568 52.3012C16.3047 57.9491 23.9649 61.1221 31.9522 61.1221L31.9522 50.5814C26.7605 50.5814 21.7813 48.5189 18.1102 44.8478C14.4391 41.1767 12.3766 36.1976 12.3766 31.0058L1.83594 31.0058Z"
            fill="url(#paint3_linear_10743_353686_3)"
        />
        <mask
            id="mask0_10743_353686"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="1"
            y="0"
            width="62"
            height="62"
        >
            <circle cx="31.9522" cy="31.0059" r="30.1163" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_10743_353686)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M33.458 0.889648H30.4464V29.3839H1.71973V32.3956H30.4464V61.1222H33.458V32.3956H61.9523V29.3839H33.458V0.889648Z"
                fill="url(#paint4_radial_10743_353686)"
            />
        </g>
        <circle cx="31.8361" cy="30.89" r="19.5756" fill="#233A55" />
        <circle opacity="0.12" cx="31.836" cy="30.8902" r="13.5523" fill="white" />
        <g opacity="0.24">
            <path
                d="M31.836 17.3379C30.511 17.3379 29.2405 17.4693 28.0244 17.7322L28.3874 19.1634C28.4418 19.4554 28.9501 19.879 29.4946 19.879H34.1774C34.7219 19.879 35.2301 19.4554 35.3027 19.1634L35.6476 17.7322C34.4315 17.4693 33.161 17.3379 31.836 17.3379Z"
                fill="white"
            />
            <path
                d="M20.0519 24.138C19.5008 25.1066 19.1019 26.1121 18.8369 27.1257L20.4428 27.5207C20.7637 27.5938 21.406 27.4264 21.6366 27.0414L23.6284 23.5809C23.8582 23.181 23.6293 22.6257 23.3697 22.445L22.054 21.5276C21.2925 22.2981 20.6029 23.1694 20.0519 24.138Z"
                fill="white"
            />
            <path
                d="M20.0492 37.6204C20.5919 38.5925 21.274 39.4687 22.028 40.2597L23.3515 39.3549C23.6135 39.1619 23.8471 38.6092 23.6208 38.2078L21.6578 34.7492C21.4314 34.3479 20.7906 34.1752 20.4682 34.2602L18.859 34.6407C19.1153 35.6553 19.5056 36.6631 20.0492 37.6204Z"
                fill="white"
            />
            <path
                d="M31.836 44.4425C33.161 44.4425 34.4315 44.2965 35.6476 44.0483L35.3027 42.6171C35.2301 42.325 34.7219 41.9015 34.1774 41.9015H29.4946C28.9501 41.9015 28.4418 42.325 28.3874 42.6171L28.0244 44.0483C29.2405 44.2965 30.511 44.4425 31.836 44.4425Z"
                fill="white"
            />
            <path
                d="M43.615 37.6383C44.1904 36.6885 44.5798 35.6874 44.8517 34.6768L43.246 34.2723C42.9245 34.1825 42.2802 34.3456 42.0474 34.7436L40.0298 38.1725C39.8137 38.5697 40.0227 39.1266 40.2822 39.3235L41.5938 40.2479C42.3774 39.4675 43.0569 38.6023 43.615 37.6383Z"
                fill="white"
            />
            <path
                d="M43.6168 24.134C43.0617 23.1671 42.3849 22.2989 41.6031 21.53L40.2886 22.4516C40.0291 22.6331 39.8185 23.19 40.0332 23.5883L42.0394 27.0425C42.2716 27.4267 42.9154 27.5921 43.2365 27.518L44.8434 27.1179C44.5747 26.1051 44.1885 25.1017 43.6168 24.134Z"
                fill="white"
            />
        </g>
        <path
            d="M31.8362 22.7578C36.318 22.7578 39.9676 26.4075 39.9676 30.8892C39.9676 35.3709 36.318 39.0206 31.8362 39.0206C27.3545 39.0206 23.7048 35.3709 23.7048 30.8892C23.7048 26.4075 27.3545 22.7578 31.8362 22.7578ZM31.8362 23.1748C27.5843 23.1748 24.1218 26.6373 24.1218 30.8892C24.1218 35.1411 27.5843 38.6036 31.8362 38.6036C36.0881 38.6036 39.5506 35.1411 39.5506 30.8892C39.5506 26.6373 36.0881 23.1748 31.8362 23.1748Z"
            fill="white"
            fill-opacity="0.3"
        />
        <g filter="url(#filter0_f_10743_353686)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.46362 31.0064H3.09104C3.09104 38.6609 6.13179 46.0019 11.5444 51.4144C16.9569 56.827 24.2979 59.8677 31.9524 59.8677V60.4951C24.1315 60.4951 16.6309 57.3883 11.1007 51.8581C5.57047 46.3279 2.46362 38.8273 2.46362 31.0064Z"
                fill="url(#paint5_radial_10743_353686)"
            />
        </g>
        <g filter="url(#filter1_f_10743_353686)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M61.4409 31.0064H60.8135C60.8135 38.6609 57.7728 46.0019 52.3602 51.4144C46.9476 56.827 39.6066 59.8677 31.9521 59.8677V60.4951C39.773 60.4951 47.2736 57.3883 52.8038 51.8581C58.3341 46.3279 61.4409 38.8273 61.4409 31.0064Z"
                fill="url(#paint6_radial_10743_353686)"
            />
        </g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.4731 31.0063H12.3766C12.3766 36.198 14.4391 41.1772 18.1102 44.8483C21.7813 48.5194 26.7604 50.5819 31.9522 50.5819V51.4854C26.5208 51.4854 21.3119 49.3277 17.4713 45.4872C13.6308 41.6466 11.4731 36.4377 11.4731 31.0063Z"
            fill="url(#paint7_radial_10743_353686)"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M52.4314 31.0063H51.5279C51.5279 36.198 49.4655 41.1772 45.7944 44.8483C42.1232 48.5194 37.1441 50.5819 31.9523 50.5819V51.4854C37.3837 51.4854 42.5926 49.3277 46.4332 45.4872C50.2738 41.6466 52.4314 36.4377 52.4314 31.0063Z"
            fill="url(#paint8_radial_10743_353686)"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.4731 31.0064H12.3766C12.3766 25.8146 14.4391 20.8355 18.1102 17.1644C21.7813 13.4933 26.7604 11.4308 31.9522 11.4308V10.5273C26.5208 10.5273 21.3119 12.685 17.4713 16.5255C13.6308 20.3661 11.4731 25.575 11.4731 31.0064Z"
            fill="url(#paint9_radial_10743_353686)"
        />
        <g filter="url(#filter2_f_10743_353686)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.46338 31.0044H3.0908C3.0908 23.3499 6.13155 16.0089 11.5441 10.5963C16.9567 5.18378 24.2977 2.14305 31.9522 2.14305V1.51563C24.1313 1.51562 16.6307 4.62247 11.1005 10.1527C5.57023 15.6829 2.46338 23.1835 2.46338 31.0044Z"
                fill="url(#paint10_radial_10743_353686)"
            />
        </g>
        <g filter="url(#filter3_f_10743_353686)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M61.4409 31.0053H60.8135C60.8135 23.3508 57.7728 16.0099 52.3602 10.5973C46.9476 5.18476 39.6066 2.14402 31.9521 2.14402V1.5166C39.773 1.5166 47.2736 4.62344 52.8038 10.1537C58.3341 15.6839 61.4409 23.1844 61.4409 31.0053Z"
                fill="url(#paint11_radial_10743_353686)"
            />
        </g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M52.4314 31.0064H51.5279C51.5279 25.8146 49.4655 20.8355 45.7944 17.1644C42.1232 13.4933 37.1441 11.4308 31.9523 11.4308V10.5273C37.3837 10.5273 42.5926 12.685 46.4332 16.5255C50.2738 20.3661 52.4314 25.575 52.4314 31.0064Z"
            fill="url(#paint12_radial_10743_353686)"
        />
        <g filter="url(#filter4_f_10743_353686)">
            <path d="M12.9485 11.9951L14.0779 17.6419L18.5954 13.1244L12.9485 11.9951Z" fill="#CBF883" />
        </g>
        <path d="M12.9485 11.9951L14.0779 17.6419L18.5954 13.1244L12.9485 11.9951Z" fill="white" />
        <path
            d="M12.7271 12.0394L12.6606 11.7071L12.9928 11.7736L18.6397 12.9029L19.0535 12.9857L18.7551 13.2841L14.2376 17.8016L13.9392 18.1L13.8564 17.6862L12.7271 12.0394Z"
            stroke="white"
            stroke-opacity="0.3"
            stroke-width="0.451744"
        />
        <g filter="url(#filter5_f_10743_353686)">
            <path d="M12.9485 50.0098L14.0779 44.363L18.5954 48.8805L12.9485 50.0098Z" fill="#CBF883" />
        </g>
        <path d="M12.9485 50.0098L14.0779 44.363L18.5954 48.8805L12.9485 50.0098Z" fill="white" />
        <path
            d="M12.7271 49.9655L12.6606 50.2978L12.9928 50.2313L18.6397 49.1019L19.0535 49.0192L18.7551 48.7207L14.2376 44.2033L13.9392 43.9048L13.8564 44.3187L12.7271 49.9655Z"
            stroke="white"
            stroke-opacity="0.3"
            stroke-width="0.451744"
        />
        <g filter="url(#filter6_f_10743_353686)">
            <path d="M50.9555 11.9951L49.8261 17.6419L45.3087 13.1244L50.9555 11.9951Z" fill="#CBF883" />
        </g>
        <path d="M50.9555 11.9951L49.8261 17.6419L45.3087 13.1244L50.9555 11.9951Z" fill="white" />
        <path
            d="M51.177 12.0394L51.2434 11.7071L50.9112 11.7736L45.2644 12.9029L44.8505 12.9857L45.149 13.2841L49.6664 17.8016L49.9649 18.1L50.0476 17.6862L51.177 12.0394Z"
            stroke="white"
            stroke-opacity="0.3"
            stroke-width="0.451744"
        />
        <g filter="url(#filter7_f_10743_353686)">
            <path d="M51.5203 50.5742L50.0144 43.045L43.991 49.0684L51.5203 50.5742Z" fill="#CBF883" />
        </g>
        <path d="M50.9555 50.0098L49.8261 44.363L45.3087 48.8805L50.9555 50.0098Z" fill="white" />
        <path
            d="M51.177 49.9655L51.2434 50.2978L50.9112 50.2313L45.2644 49.1019L44.8505 49.0192L45.149 48.7207L49.6664 44.2033L49.9649 43.9048L50.0476 44.3187L51.177 49.9655Z"
            stroke="white"
            stroke-opacity="0.3"
            stroke-width="0.451744"
        />
        <defs>
            <filter
                id="filter0_f_10743_353686"
                x="0.957809"
                y="29.501"
                width="32.5004"
                height="32.4999"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="0.752907" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <filter
                id="filter1_f_10743_353686"
                x="30.4463"
                y="29.501"
                width="32.5004"
                height="32.4999"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="0.752907" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <filter
                id="filter2_f_10743_353686"
                x="0.957565"
                y="0.00981081"
                width="32.5004"
                height="32.4999"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="0.752907" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <filter
                id="filter3_f_10743_353686"
                x="30.4463"
                y="0.0107874"
                width="32.5004"
                height="32.4999"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="0.752907" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <filter
                id="filter4_f_10743_353686"
                x="9.93686"
                y="8.98349"
                width="11.6702"
                height="11.6697"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="1.50581" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <filter
                id="filter5_f_10743_353686"
                x="9.93686"
                y="41.3517"
                width="11.6702"
                height="11.6697"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="1.50581" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <filter
                id="filter6_f_10743_353686"
                x="42.297"
                y="8.98349"
                width="11.6702"
                height="11.6697"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="1.50581" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <filter
                id="filter7_f_10743_353686"
                x="40.9793"
                y="40.0333"
                width="13.5526"
                height="13.5526"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="1.50581" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <linearGradient
                id="paint0_linear_10743_353686_1"
                x1="31.9522"
                y1="31.0059"
                x2="10.8708"
                y2="9.92453"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#070A0C" />
                <stop offset="1" stop-color="#FF91C3" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_10743_353686_2"
                x1="31.9523"
                y1="31.0059"
                x2="53.0337"
                y2="9.92453"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#070A0C" />
                <stop offset="1" stop-color="#308FFF" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_10743_353686_4"
                x1="31.9523"
                y1="31.0058"
                x2="53.0337"
                y2="52.0872"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#070A0C" />
                <stop offset="1" stop-color="#7FF046" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_10743_353686_3"
                x1="31.9522"
                y1="31.0058"
                x2="10.8708"
                y2="52.0872"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#070A0C" />
                <stop offset="1" stop-color="#FFE248" />
            </linearGradient>
            <radialGradient
                id="paint4_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(31.836 31.0059) rotate(90) scale(37.6454)"
            >
                <stop offset="0.645" stop-color="#233A55" />
                <stop offset="0.85" stop-color="#4D80BB" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint5_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(11.3536 51.6049) rotate(-133.152) scale(23.7772 7.38503)"
            >
                <stop stop-color="white" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint6_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(52.551 51.6049) rotate(-46.8475) scale(23.7772 7.38503)"
            >
                <stop stop-color="white" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint7_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(17.6469 45.3114) rotate(-133.152) scale(16.5125 5.12868)"
            >
                <stop stop-color="white" stop-opacity="0.8" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint8_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(46.2576 45.3114) rotate(-46.8476) scale(16.5125 5.12868)"
            >
                <stop stop-color="white" stop-opacity="0.8" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint9_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(17.6469 16.7013) rotate(133.152) scale(16.5125 5.12868)"
            >
                <stop stop-color="white" stop-opacity="0.8" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint10_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(11.3533 10.4058) rotate(133.152) scale(23.7772 7.38503)"
            >
                <stop stop-color="white" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint11_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(52.551 10.4068) rotate(46.8475) scale(23.7772 7.38503)"
            >
                <stop stop-color="white" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint12_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(46.2576 16.7013) rotate(46.8476) scale(16.5125 5.12868)"
            >
                <stop stop-color="white" stop-opacity="0.8" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
        </defs>
    </svg>
{:else}
    <svg width="100%" height="100%" viewBox="0 0 63 62" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.83594 31.0059C1.83594 23.0186 5.0089 15.3584 10.6568 9.7105C16.3047 4.0626 23.9649 0.889648 31.9522 0.889648L31.9522 11.4303C26.7605 11.4303 21.7813 13.4928 18.1102 17.1639C14.4391 20.835 12.3766 25.8142 12.3766 31.0059L1.83594 31.0059Z"
            fill="url(#paint0_linear_10743_353686)"
        />
        <path
            d="M62.0686 31.0059C62.0686 23.0186 58.8956 15.3584 53.2477 9.7105C47.5998 4.0626 39.9397 0.889648 31.9523 0.889648L31.9523 11.4303C37.1441 11.4303 42.1232 13.4928 45.7943 17.1639C49.4655 20.835 51.5279 25.8142 51.5279 31.0059L62.0686 31.0059Z"
            fill="url(#paint1_linear_10743_353686)"
        />
        <path
            d="M62.0686 31.0058C62.0686 38.9931 58.8956 46.6533 53.2477 52.3012C47.5998 57.9491 39.9397 61.1221 31.9523 61.1221L31.9523 50.5814C37.1441 50.5814 42.1232 48.5189 45.7943 44.8478C49.4655 41.1767 51.5279 36.1976 51.5279 31.0058L62.0686 31.0058Z"
            fill="url(#paint2_linear_10743_353686)"
        />
        <path
            d="M1.83594 31.0058C1.83594 38.9931 5.0089 46.6533 10.6568 52.3012C16.3047 57.9491 23.9649 61.1221 31.9522 61.1221L31.9522 50.5814C26.7605 50.5814 21.7813 48.5189 18.1102 44.8478C14.4391 41.1767 12.3766 36.1976 12.3766 31.0058L1.83594 31.0058Z"
            fill="url(#paint3_linear_10743_353686)"
        />
        <mask
            id="mask0_10743_353686"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="1"
            y="0"
            width="62"
            height="62"
        >
            <circle cx="31.9522" cy="31.0059" r="30.1163" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_10743_353686)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M33.458 0.889648H30.4464V29.3839H1.71973V32.3956H30.4464V61.1222H33.458V32.3956H61.9523V29.3839H33.458V0.889648Z"
                fill="url(#paint4_radial_10743_353686)"
            />
        </g>
        <circle cx="31.8361" cy="30.89" r="19.5756" fill="#233A55" />
        <circle opacity="0.12" cx="31.836" cy="30.8902" r="13.5523" fill="white" />
        <g opacity="0.24">
            <path
                d="M31.836 17.3379C30.511 17.3379 29.2405 17.4693 28.0244 17.7322L28.3874 19.1634C28.4418 19.4554 28.9501 19.879 29.4946 19.879H34.1774C34.7219 19.879 35.2301 19.4554 35.3027 19.1634L35.6476 17.7322C34.4315 17.4693 33.161 17.3379 31.836 17.3379Z"
                fill="white"
            />
            <path
                d="M20.0519 24.138C19.5008 25.1066 19.1019 26.1121 18.8369 27.1257L20.4428 27.5207C20.7637 27.5938 21.406 27.4264 21.6366 27.0414L23.6284 23.5809C23.8582 23.181 23.6293 22.6257 23.3697 22.445L22.054 21.5276C21.2925 22.2981 20.6029 23.1694 20.0519 24.138Z"
                fill="white"
            />
            <path
                d="M20.0492 37.6204C20.5919 38.5925 21.274 39.4687 22.028 40.2597L23.3515 39.3549C23.6135 39.1619 23.8471 38.6092 23.6208 38.2078L21.6578 34.7492C21.4314 34.3479 20.7906 34.1752 20.4682 34.2602L18.859 34.6407C19.1153 35.6553 19.5056 36.6631 20.0492 37.6204Z"
                fill="white"
            />
            <path
                d="M31.836 44.4425C33.161 44.4425 34.4315 44.2965 35.6476 44.0483L35.3027 42.6171C35.2301 42.325 34.7219 41.9015 34.1774 41.9015H29.4946C28.9501 41.9015 28.4418 42.325 28.3874 42.6171L28.0244 44.0483C29.2405 44.2965 30.511 44.4425 31.836 44.4425Z"
                fill="white"
            />
            <path
                d="M43.615 37.6383C44.1904 36.6885 44.5798 35.6874 44.8517 34.6768L43.246 34.2723C42.9245 34.1825 42.2802 34.3456 42.0474 34.7436L40.0298 38.1725C39.8137 38.5697 40.0227 39.1266 40.2822 39.3235L41.5938 40.2479C42.3774 39.4675 43.0569 38.6023 43.615 37.6383Z"
                fill="white"
            />
            <path
                d="M43.6168 24.134C43.0617 23.1671 42.3849 22.2989 41.6031 21.53L40.2886 22.4516C40.0291 22.6331 39.8185 23.19 40.0332 23.5883L42.0394 27.0425C42.2716 27.4267 42.9154 27.5921 43.2365 27.518L44.8434 27.1179C44.5747 26.1051 44.1885 25.1017 43.6168 24.134Z"
                fill="white"
            />
        </g>
        <path
            d="M31.8362 22.7578C36.318 22.7578 39.9676 26.4075 39.9676 30.8892C39.9676 35.3709 36.318 39.0206 31.8362 39.0206C27.3545 39.0206 23.7048 35.3709 23.7048 30.8892C23.7048 26.4075 27.3545 22.7578 31.8362 22.7578ZM31.8362 23.1748C27.5843 23.1748 24.1218 26.6373 24.1218 30.8892C24.1218 35.1411 27.5843 38.6036 31.8362 38.6036C36.0881 38.6036 39.5506 35.1411 39.5506 30.8892C39.5506 26.6373 36.0881 23.1748 31.8362 23.1748Z"
            fill="white"
            fill-opacity="0.3"
        />
        <g filter="url(#filter0_f_10743_353686)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.46362 31.0064H3.09104C3.09104 38.6609 6.13179 46.0019 11.5444 51.4144C16.9569 56.827 24.2979 59.8677 31.9524 59.8677V60.4951C24.1315 60.4951 16.6309 57.3883 11.1007 51.8581C5.57047 46.3279 2.46362 38.8273 2.46362 31.0064Z"
                fill="url(#paint5_radial_10743_353686)"
            />
        </g>
        <g filter="url(#filter1_f_10743_353686)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M61.4409 31.0064H60.8135C60.8135 38.6609 57.7728 46.0019 52.3602 51.4144C46.9476 56.827 39.6066 59.8677 31.9521 59.8677V60.4951C39.773 60.4951 47.2736 57.3883 52.8038 51.8581C58.3341 46.3279 61.4409 38.8273 61.4409 31.0064Z"
                fill="url(#paint6_radial_10743_353686)"
            />
        </g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.4731 31.0063H12.3766C12.3766 36.198 14.4391 41.1772 18.1102 44.8483C21.7813 48.5194 26.7604 50.5819 31.9522 50.5819V51.4854C26.5208 51.4854 21.3119 49.3277 17.4713 45.4872C13.6308 41.6466 11.4731 36.4377 11.4731 31.0063Z"
            fill="url(#paint7_radial_10743_353686)"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M52.4314 31.0063H51.5279C51.5279 36.198 49.4655 41.1772 45.7944 44.8483C42.1232 48.5194 37.1441 50.5819 31.9523 50.5819V51.4854C37.3837 51.4854 42.5926 49.3277 46.4332 45.4872C50.2738 41.6466 52.4314 36.4377 52.4314 31.0063Z"
            fill="url(#paint8_radial_10743_353686)"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.4731 31.0064H12.3766C12.3766 25.8146 14.4391 20.8355 18.1102 17.1644C21.7813 13.4933 26.7604 11.4308 31.9522 11.4308V10.5273C26.5208 10.5273 21.3119 12.685 17.4713 16.5255C13.6308 20.3661 11.4731 25.575 11.4731 31.0064Z"
            fill="url(#paint9_radial_10743_353686)"
        />
        <g filter="url(#filter2_f_10743_353686)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.46338 31.0044H3.0908C3.0908 23.3499 6.13155 16.0089 11.5441 10.5963C16.9567 5.18378 24.2977 2.14305 31.9522 2.14305V1.51563C24.1313 1.51562 16.6307 4.62247 11.1005 10.1527C5.57023 15.6829 2.46338 23.1835 2.46338 31.0044Z"
                fill="url(#paint10_radial_10743_353686)"
            />
        </g>
        <g filter="url(#filter3_f_10743_353686)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M61.4409 31.0053H60.8135C60.8135 23.3508 57.7728 16.0099 52.3602 10.5973C46.9476 5.18476 39.6066 2.14402 31.9521 2.14402V1.5166C39.773 1.5166 47.2736 4.62344 52.8038 10.1537C58.3341 15.6839 61.4409 23.1844 61.4409 31.0053Z"
                fill="url(#paint11_radial_10743_353686)"
            />
        </g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M52.4314 31.0064H51.5279C51.5279 25.8146 49.4655 20.8355 45.7944 17.1644C42.1232 13.4933 37.1441 11.4308 31.9523 11.4308V10.5273C37.3837 10.5273 42.5926 12.685 46.4332 16.5255C50.2738 20.3661 52.4314 25.575 52.4314 31.0064Z"
            fill="url(#paint12_radial_10743_353686)"
        />
        <g filter="url(#filter4_f_10743_353686)">
            <path d="M12.9485 11.9951L14.0779 17.6419L18.5954 13.1244L12.9485 11.9951Z" fill="#CBF883" />
        </g>
        <path d="M12.9485 11.9951L14.0779 17.6419L18.5954 13.1244L12.9485 11.9951Z" fill="white" />
        <path
            d="M12.7271 12.0394L12.6606 11.7071L12.9928 11.7736L18.6397 12.9029L19.0535 12.9857L18.7551 13.2841L14.2376 17.8016L13.9392 18.1L13.8564 17.6862L12.7271 12.0394Z"
            stroke="white"
            stroke-opacity="0.3"
            stroke-width="0.451744"
        />
        <g filter="url(#filter5_f_10743_353686)">
            <path d="M12.9485 50.0098L14.0779 44.363L18.5954 48.8805L12.9485 50.0098Z" fill="#CBF883" />
        </g>
        <path d="M12.9485 50.0098L14.0779 44.363L18.5954 48.8805L12.9485 50.0098Z" fill="white" />
        <path
            d="M12.7271 49.9655L12.6606 50.2978L12.9928 50.2313L18.6397 49.1019L19.0535 49.0192L18.7551 48.7207L14.2376 44.2033L13.9392 43.9048L13.8564 44.3187L12.7271 49.9655Z"
            stroke="white"
            stroke-opacity="0.3"
            stroke-width="0.451744"
        />
        <g filter="url(#filter6_f_10743_353686)">
            <path d="M50.9555 11.9951L49.8261 17.6419L45.3087 13.1244L50.9555 11.9951Z" fill="#CBF883" />
        </g>
        <path d="M50.9555 11.9951L49.8261 17.6419L45.3087 13.1244L50.9555 11.9951Z" fill="white" />
        <path
            d="M51.177 12.0394L51.2434 11.7071L50.9112 11.7736L45.2644 12.9029L44.8505 12.9857L45.149 13.2841L49.6664 17.8016L49.9649 18.1L50.0476 17.6862L51.177 12.0394Z"
            stroke="white"
            stroke-opacity="0.3"
            stroke-width="0.451744"
        />
        <g filter="url(#filter7_f_10743_353686)">
            <path d="M51.5203 50.5742L50.0144 43.045L43.991 49.0684L51.5203 50.5742Z" fill="#CBF883" />
        </g>
        <path d="M50.9555 50.0098L49.8261 44.363L45.3087 48.8805L50.9555 50.0098Z" fill="white" />
        <path
            d="M51.177 49.9655L51.2434 50.2978L50.9112 50.2313L45.2644 49.1019L44.8505 49.0192L45.149 48.7207L49.6664 44.2033L49.9649 43.9048L50.0476 44.3187L51.177 49.9655Z"
            stroke="white"
            stroke-opacity="0.3"
            stroke-width="0.451744"
        />
        <defs>
            <filter
                id="filter0_f_10743_353686"
                x="0.957809"
                y="29.501"
                width="32.5004"
                height="32.4999"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="0.752907" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <filter
                id="filter1_f_10743_353686"
                x="30.4463"
                y="29.501"
                width="32.5004"
                height="32.4999"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="0.752907" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <filter
                id="filter2_f_10743_353686"
                x="0.957565"
                y="0.00981081"
                width="32.5004"
                height="32.4999"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="0.752907" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <filter
                id="filter3_f_10743_353686"
                x="30.4463"
                y="0.0107874"
                width="32.5004"
                height="32.4999"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="0.752907" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <filter
                id="filter4_f_10743_353686"
                x="9.93686"
                y="8.98349"
                width="11.6702"
                height="11.6697"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="1.50581" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <filter
                id="filter5_f_10743_353686"
                x="9.93686"
                y="41.3517"
                width="11.6702"
                height="11.6697"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="1.50581" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <filter
                id="filter6_f_10743_353686"
                x="42.297"
                y="8.98349"
                width="11.6702"
                height="11.6697"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="1.50581" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <filter
                id="filter7_f_10743_353686"
                x="40.9793"
                y="40.0333"
                width="13.5526"
                height="13.5526"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="1.50581" result="effect1_foregroundBlur_10743_353686" />
            </filter>
            <linearGradient
                id="paint0_linear_10743_353686"
                x1="31.9522"
                y1="31.0059"
                x2="10.8708"
                y2="9.92453"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#070A0C" />
                <stop offset="1" stop-color="#C6C6C6" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_10743_353686"
                x1="31.9523"
                y1="31.0059"
                x2="53.0337"
                y2="9.92453"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#0D171B" />
                <stop offset="1" stop-color="#8EDFFF" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_10743_353686"
                x1="31.9523"
                y1="31.0058"
                x2="53.0337"
                y2="52.0872"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#391103" />
                <stop offset="1" stop-color="#FFAE92" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_10743_353686"
                x1="31.9522"
                y1="31.0058"
                x2="10.8708"
                y2="52.0872"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#14002E" />
                <stop offset="1" stop-color="#BB85FF" />
            </linearGradient>
            <radialGradient
                id="paint4_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(31.836 31.0059) rotate(90) scale(37.6454)"
            >
                <stop offset="0.645" stop-color="#233A55" />
                <stop offset="0.85" stop-color="#4D80BB" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint5_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(11.3536 51.6049) rotate(-133.152) scale(23.7772 7.38503)"
            >
                <stop stop-color="white" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint6_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(52.551 51.6049) rotate(-46.8475) scale(23.7772 7.38503)"
            >
                <stop stop-color="white" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint7_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(17.6469 45.3114) rotate(-133.152) scale(16.5125 5.12868)"
            >
                <stop stop-color="white" stop-opacity="0.8" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint8_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(46.2576 45.3114) rotate(-46.8476) scale(16.5125 5.12868)"
            >
                <stop stop-color="white" stop-opacity="0.8" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint9_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(17.6469 16.7013) rotate(133.152) scale(16.5125 5.12868)"
            >
                <stop stop-color="white" stop-opacity="0.8" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint10_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(11.3533 10.4058) rotate(133.152) scale(23.7772 7.38503)"
            >
                <stop stop-color="white" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint11_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(52.551 10.4068) rotate(46.8475) scale(23.7772 7.38503)"
            >
                <stop stop-color="white" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint12_radial_10743_353686"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(46.2576 16.7013) rotate(46.8476) scale(16.5125 5.12868)"
            >
                <stop stop-color="white" stop-opacity="0.8" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
        </defs>
    </svg>
{/if}
